// TODO: Проверить и отладить отработку нажатия на маркер на странице контактов

/**
 * @version 1.0
 * @author Kelnik Studios {http://kelnik.ru}
 */
import aboutBalloonTemplate from './balloon/about.twig';
import aboutMarkerTemplate from './marker/about.twig';
import balloonTemplate from './balloon/default.twig';
import mapUtils from './utils';
import markerTemplate from './marker/default.twig';
import Observer from '../../common/scripts/observer';
import Panel from './panel';

const observer = new Observer();
const panel = new Panel();

class Marker {
    constructor() {
        /**
         * Объект яндекс карт созданный в модуле load
         */
        this.ymaps = window.ymaps;

        /**
         * Брейкпоинт после которого маркерты открываются не по клику, а по ховеру.
         * @type {number}
         */
        this.desktopBreakpoint = 1280;
    }

    /**
     * Вызывает соотвествующий метод для типа маркера (с балуном или без)
     * @param {object} element - элемент массива маркера
     * @returns {function} функции инициализации маркеров соотвествующего типа
     * @public
     */
    createMarker(element) {
        this._setSettings(element);

        if (!element.balloon.title && !element.balloon.text) {
            return this._initWithoutBalloon();
        }

        return this._initWithBallon();
    }

    /**
     * Создает HTML маркер
     * @param {object} element - элемент массива маркеров
     * @returns {function} функции инициализации маркера на карте параметрического поиска
     * @public
     */
    createHtmlMarker(element) {
        this._setTemplateMarker(element);
        this._setTemplateBalloon(element);
        this.ballon = element;

        this.office = element.office || false;
        this.route = element.route || false;

        const CustomLayoutClass = this.ymaps.templateLayoutFactory.createClass(this.markerTemplate(element));
        const zIndex = element.zIndex || false;
        const isBalloon = element.balloon;
        const balloonLayout = mapUtils.needBalloonPanel() || !isBalloon ?
            false :
            this._createBalloonContentLayout();

        const marker = new this.ymaps.Placemark(element.coords, {}, {
            type                 : 'Placemark',
            balloonLayout,
            iconLayout           : CustomLayoutClass,
            hideIconOnBalloonOpen: this.hideIconOnBalloonOpen,
            // id офиса (только для страницы контакты)
            office               : this.office,
            // текущий шаблон для баллуна
            template             : this.balloonTemplate,
            // все данные от бэкенда
            data                 : element,
            // фигура активной области для маркера
            iconShape            : this._setIconShape(element),
            // z-index для маркера
            zIndex,
            // экземпляр созданное панельки для маркера
            panel,
            cursor               : isBalloon ? 'pointer' : 'default',
            isBalloon
        });

        this._bindEventsMarker(marker, element);

        // Для табов, если есть такой флаг то изначально маркер будет скрыт
        if (element.isHidden) {
            marker.options.set('visible', false);
        }

        return marker;
    }

    /**
     * Метод устанавливает настройки для балуна
     * @param {object} marker - элемент массива данных markers
     * @private
     */
    _setSettings(marker) {
        const def = {};

        def.lat = 59.939014;
        def.lon = 30.315545;
        def.iconWidth = 24;
        def.iconHeight = 24;
        def.offsetTop = 0;
        def.offsetLeft = 0;

        this.type = marker.type || 'Point';
        this.coords = marker.coords || [def.lat, def.lon];
        this.iconLayout = 'default#image';
        this.iconImageHref = marker.icon || '../../webicons/map/media/markers/marker.svg';
        this.iconImageSize = marker.size || [def.iconWidth, def.iconHeight];
        this.iconImageOffset = marker.offset || [def.offsetTop, def.offsetLeft];
        this.route = marker.route || false;

        // Копирует все данные из маркера в объект балуна
        this.ballon = marker;
    }

    /**
     * Инициализирует маркер без балуна.
     * @returns {object} - placemark объект маркера.
     * @private
     */
    _initWithoutBalloon() {
        return new this.ymaps.Placemark(this.coords, {type: this.type}, {
            iconLayout     : this.iconLayout,
            iconImageHref  : this.iconImageHref,
            iconImageSize  : this.iconImageSize,
            iconImageOffset: this.iconImageOffset
        });
    }

    /**
     * Инициализирует маркер с балуном.
     * @returns {object} - placemark объект маркера.
     * @private
     */
    _initWithBallon() {
        this._setTemplateBalloon();

        const marker = new this.ymaps.Placemark(this.coords, {type: this.type}, {
            balloonLayout        : this._createBalloonContentLayout(),
            iconLayout           : this.iconLayout,
            iconImageHref        : this.iconImageHref,
            iconImageSize        : this.iconImageSize,
            iconImageOffset      : this.iconImageOffset,
            route                : this.route,
            // текущий шаблон для баллуна
            template             : this.balloonTemplate,
            // все данные от бэкенда
            data                 : this.ballon,
            hideIconOnBalloonOpen: false
        });

        this._bindEventsMarker(marker);

        return marker;
    }

    /**
     * Устанавливает шаблон для маркера исходя из модификатора.
     * @param {object} element - данные для маркера от бэкенда.
     * @private
     */
    _setTemplateMarker(element) {
        switch (element.modifyClass) {
            case 'yandex-map-about':
                this.hideIconOnBalloonOpen = false;
                this.markerTemplate = aboutMarkerTemplate;
                break;
            default:
                this.hideIconOnBalloonOpen = false;
                this.markerTemplate = markerTemplate;
                break;
        }
    }

    /**
     * Устанавливает шаблон для баллуна исходя из модификатора.
     * @param {object} element - данные для маркера от бэкенда
     */
    _setTemplateBalloon(element) {
        switch (element.modifyClass) {
            case 'yandex-map-about':
                this.balloonTemplate = aboutBalloonTemplate;
                break;
            default:
                this.balloonTemplate = balloonTemplate;
                break;
        }
    }

    /**
     * Устанавливает активную область для HTML-маркера.
     * @param {object} element - элемент массива маркеров
     * @return {object} iconShape - яндексовый полигон
     */
    _setIconShape(element) {
        const startSize = 0;

        if (mapUtils.needBalloonPanel()) {
            this.iconImageSize = [Number(element.size.height), Number(element.size.height)];
        } else {
            this.iconImageSize = [-Number(element.size.width), -Number(element.size.height)];
        }

        return {
            type       : 'Rectangle',
            coordinates: [[startSize, startSize], this.iconImageSize]
        };
    }

    /**
     * Создает шаблон балуна
     * @returns {object} - шаблон балуна для использования в методе инициализации маркеров.
     * @private
     */
    _createBalloonContentLayout() {
        const that = this;
        const BalloonLayout = this.ymaps.templateLayoutFactory.createClass(this.balloonTemplate(this.ballon), {

            /**
             * Строит экземпляр макета на основе шаблона и добавляет его в родительский HTML-элемент.
             * @see https://api.yandex.ru/maps/doc/jsapi/2.1/ref/reference/layout.templateBased.Base.xml#build
             */
            build() {
                this.constructor.superclass.build.call(this);
                this.baloon = document.querySelector('.j-yandex-map-baloon');

                that.markerOffset(this.baloon);
            },

            /**
             * Удаляет содержимое макета из DOM.
             * @see https://api.yandex.ru/maps/doc/jsapi/2.1/ref/reference/layout.templateBased.Base.xml#clear
             */
            clear() {
                this.constructor.superclass.clear.call(this);
            },

            /**
             * Закрывает балун при клике на крестик, кидая событие "userclose" на макете.
             * @see https://api.yandex.ru/maps/doc/jsapi/2.1/ref/reference/IBalloonLayout.xml#event-userclose
             * @param {event} event - событие
             */
            onCloseClick(event) {
                event.preventDefault();

                this.events.fire('userclose');
            },

            /**
             * Метод будет вызван системой шаблонов АПИ при изменении размеров вложенного макета.
             * @see https://api.yandex.ru/maps/doc/jsapi/2.1/ref/reference/IBalloonLayout.xml#event-userclose
             */
            onSublayoutSizeChange() {
                BalloonLayout.superclass.onSublayoutSizeChange.apply(this, arguments);

                if (!this.baloon) {
                    return;
                }

                that.markerOffset(this.baloon);

                this.events.fire('shapechange');
            },

            /**
             * Используется для автопозиционирования (balloonAutoPan).
             * @see https://api.yandex.ru/maps/doc/jsapi/2.1/ref/reference/ILayout.xml#getClientBounds
             * @returns {object} - Координаты левого верхнего и правого нижнего углов шаблона относительни точки привязки.
             */
            getShape() {
                if (!this.baloon) {
                    return BalloonLayout.superclass.getShape.call(this);
                }

                const balloonHeight = this.baloon.offsetHeight;
                const ballonWidth = this.baloon.offsetWidth;
                const positionTop = this.baloon.offsetTop;
                const positionLeft = this.baloon.offsetLeft;

                const bounds = [[positionLeft, positionTop], [positionLeft + ballonWidth, positionTop + balloonHeight]];

                return new window.ymaps.shape.Rectangle(new window.ymaps.geometry.pixel.Rectangle(bounds));
            }
        });

        return BalloonLayout;
    }

    /**
     * Метод сдвигает балун, чтобы "хвостик" указывал на точку привязки.
     * @see https://api.yandex.ru/maps/doc/jsapi/2.1/ref/reference/IBalloonLayout.xml#event-userclose
     * @param {object} balloon - DOM элемент балуна
     */
    markerOffset(balloon) {
        const half = 2;
        const firstElement = 0;
        const secondElement = 1;
        const widthMarker = this.iconImageSize[firstElement];
        const heightMarker = this.iconImageSize[secondElement];
        const margin = 10;

        const modify = balloon.classList.contains('yandex-map-balloon_theme_visual') ||
            balloon.classList.contains('yandex-map-balloon_theme_contacts');

        // eslint-disable-next-line no-warning-comments
        // @todo переписать этот костыль
        if (balloon.classList.contains('yandex-map-about')) {
            balloon.style.left = `${-balloon.offsetWidth - margin}px`;
            balloon.style.top = `${-(balloon.offsetHeight / half) + (widthMarker / half)}px`;
        } else if (modify) {
            const leftMargin = 28;

            balloon.style.left = `${-(balloon.offsetWidth / half) + leftMargin}px`;
            balloon.style.top = `${-balloon.offsetHeight + heightMarker}px`;
        } else {
            balloon.style.left = `${-(balloon.offsetWidth / half)}px`;
            balloon.style.top = `${-balloon.offsetHeight + heightMarker}px`;
        }
    }

    /**
     * Навешивает обработчки события клик по карте и геобъектам для закрытия балунов.
     * @param {object} map - Экзмепляр созданной карты.
     * @public
     */
    closeBallonOnClickMap(map) {
        if (window.innerWidth < this.desktopBreakpoint) {
            map.geoObjects.events.add('click', () => {
                if (map.balloon.isOpen()) {
                    map.balloon.close();
                }
            });

            map.events.add('click', () => {
                if (map.balloon.isOpen()) {
                    map.balloon.close();
                }
            });
        }
    }

    /**
     * Биндим события маркера
     * @param {Object} marker - текущий маркер
     * @param {Object} element - исходный объект текущего маркера
     */
    _bindEventsMarker(marker, element = {}) {
        if (element.target) {
            marker.events.add('click', this.onAboutMarkerClick.bind(this));
        } else if (window.innerWidth >= this.desktopBreakpoint) {
            marker.events.add('mouseenter', this.onMouseenterMarker.bind(this));
            marker.events.add('mousemove', this.onMousemoveMarker.bind(this));
            marker.events.add('mouseleave', this.onMouseleaveMarker.bind(this));
        } else {
            marker.events.add('click', this.onMouseenterMarker.bind(this));
        }
    }

    onAboutMarkerClick(event) {
        const target = event.get('target');
        const data = target.options.get('data');

        observer.publish('aboutMarkerClick', data.target);
    }

    /**
     * Событие при наведении мышки на маркер
     * @param {Object} event - объект события наведения мышки
     */
    onMouseenterMarker(event) {
        const target = event.get('target');
        const balloon = target.balloon;

        if (mapUtils.needBalloonPanel() && target.options.get('isBalloon')) {
            panel.open(target);
        } else {
            this.bindEventsBalloon(balloon);
        }
    }

    /**
     * Событие при движении мышки над маркером
     * @param {Object} event - объект события движении мышки над маркером
     */
    onMousemoveMarker(event) {
        const balloon = event.get('target').balloon;
        const isOpen = balloon.isOpen();

        if (!isOpen) {
            balloon.open();
        }
    }

    /**
     * Событие при убирания мышки с маркера
     * @param {Object} event - объект события убирания мышки с маркера
     */
    onMouseleaveMarker(event) {
        const balloon = event.get('target').balloon;

        this.timerCloseBalloon = this.getSetTimeoutClosingBalloon(balloon);
    }

    /**
     * Биндим события балуна
     * @param {Object} balloon - текущий балун
     */
    bindEventsBalloon(balloon) {
        balloon.events.add('mouseenter', this.onMouseenterBalloon.bind(this));
        balloon.events.add('mouseleave', this.onMouseleaveBalloon.bind(this));
    }

    /**
     * Событие при наведении мышки на балун
     */
    onMouseenterBalloon() {
        clearTimeout(this.timerCloseBalloon);
        this.timerCloseBalloon = null;
    }

    /**
     * Событие при убирания мышки с балуна
     * @param {Object} event - объект события потери мышки с балуна
     */
    onMouseleaveBalloon(event) {
        const balloon = event.get('target').balloon;

        this.getSetTimeoutClosingBalloon(balloon);
    }

    /**
     * Получение id установленного таймаута закрытия
     * @param {Object} balloon - текущий балун
     * @return {number} -
     */
    getSetTimeoutClosingBalloon(balloon) {
        const timeDelayClosing = 100;

        return setTimeout(() => {
            balloon.close();
        }, timeDelayClosing);
    }
}

export default Marker;
